import { PureComponent } from 'react'
import { Link } from 'react-router-dom';
import { Alert, Button, Col, Row, Table, Card, Form, Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import AnalysisExportStatusBlock from './AnalysisExportStatusBlock';
import { title_analysis_export, str_no_exams_available, linkTriggerExamLoad, apiEndpointGet } from '../Consts';
import { usePapaParse } from 'react-papaparse';

import './Analysis.css';

export default function JsonToCSV(pS, idx) {
    const ka = pS.klassenarbeiten[idx];
    const exportTS = Date.now();

    const { jsonToCSV } = usePapaParse();

    const jsonData = ({
        "fields": [
            "critA",
            "critB",
            "critC",
            "sendToUE",
            "textToUE",
            "klasse",
            "schuljahr",
            "fach",
            "exportTS"
        ],
        "data": [
            [
                pS.criterion_a === "yes" ? "true" : "false",
                pS.criterion_b === "yes" ? "true" : "false",
                pS.criterion_c === "yes" ? "true" : "false",
                pS.analysis.pos1_tf_2_sendBoard !== "unchecked" ? "true" : "false",
                pS.analysis.pos1_tf_2_sendBoard !== "unchecked" ? pS.analysis.pos1_tf_2 : "",
                ka.klasse,
                ka.schuljahr,
                ka.fach,
                exportTS
            ],
        ]
    })

    const csvData = jsonToCSV(jsonData, {
        delimiter: ";",
    });
    return csvData;
}

export class AnalysisExport extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isConnecting: false,
        };
    }

    async genFileNamePickerDialog(workLoad, idx) {
        const opts = {
            suggestedName: this.genFilename(idx),
            types: [{
                description: 'CSV Datei (Export)',
                accept: { 'text/csv': ['.csv'] },
            }],
        };
        const handle = await window.showSaveFilePicker(opts);
        const writable = await handle.createWritable();
        await writable.write(workLoad);
        await writable.close();
        this.props.backCallerSetNotice("DGSE-Analyse wurde gespeichert (Dateiname: " + handle.name + ").");
    }

    handleDirectSave = (textFile, idx) => {
        // const textFile = new Blob([JSON.stringify(this.props.parentState)], { type: 'text/plain' });
        let dlFileName = this.genFilename(idx);
        const element = document.createElement("a");
        element.href = URL.createObjectURL(textFile);
        element.download = dlFileName;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    handleSave = (idx) => {
        // const textFile = new Blob([JSON.stringify(this.props.parentState)], { type: 'text/plain' });
        // const textFile = new Blob([JsonToCSV(this.props.parentState.klassenarbeiten[idx])],
        const textFile = new Blob([JsonToCSV(this.props.parentState, idx)],
            { type: 'text/plain' });
        if (window.showSaveFilePicker) {
            this.genFileNamePickerDialog(textFile, idx);
        }
        else {
            this.handleDirectSave(textFile, idx);
        }
    }

    genFilename(idx) {
        var invalid_chars = /[^a-zA-Z0-9_-]/g;
        // const fn = new Date().toISOString().slice(0, 10) + "-DGSE-Analyse" + "-" +
        //     this.props.parentState.klassenarbeiten[idx].schuljahr.replace(invalid_chars, "") + "-" +
        //     this.props.parentState.klassenarbeiten[idx].fach.replace(invalid_chars, "") + "-" +
        //     this.props.parentState.klassenarbeiten[idx].klasse.replace(invalid_chars, "") + ".csv";
        const fn = `${new Date().toISOString().slice(0, 10)}-DGSE-Analyse-${this.props.parentState.klassenarbeiten[idx].schuljahr.replace(invalid_chars, "")}-${this.props.parentState.klassenarbeiten[idx].fach.replace(invalid_chars, "")}-${this.props.parentState.klassenarbeiten[idx].klasse.replace(invalid_chars, "")}.csv`;
        return fn;
    }

    handleTransferToWebDB(idx) {
        this.props.backCallerTransferToWebDB(idx);
    }

    handleDischChange(e) {
        this.props.backCallerDischChange(e.target.value);
    }

    handleSchoolYearChange(e) {
        this.props.backCallerSchoolYearChange(e);
    }

    handleConnectWebDB = async () => {
        this.setState({ isConnecting: true });
        try {
            await this.props.backCallerConnectWebDB();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            this.setState({ isConnecting: false });
        }
    }

    getTrafficLightColor() {
        const api = this.props.parentState.helper.api;
        // console.log("API:", api);
        if (api.connected) {
            if (api.reply_data.length > 0) {
                const hasLessons = api.reply_data.some(course =>
                    course.classes.some(classItem =>
                        classItem.lessons && classItem.lessons.length > 0
                    )
                );
                return hasLessons ? 'green' : 'orange';
            }
            else {
                return 'orange';
            }
        }
        else {
            return 'red';
        }
    }

    render() {
        const { isConnecting } = this.state;
        const trafficLightColor = this.getTrafficLightColor();
        const api = this.props.parentState.helper.api;
        return (
            <>
                <h5 className="mb-3">{title_analysis_export}</h5>
                {/* {console.log("apiEndpointGet", apiEndpointGet)} */}
                {/* STATE: Keine KA im System */}
                {this.props.parentState.klassenarbeiten.length === 0 &&
                    <Alert variant="warning" className="alert-crits">
                        <h6>Hinweis: {str_no_exams_available}<br />
                            Um Ihre DGSE-Analyse in die Webdatenbank einzuspieleln,
                            laden Sie bitte mindestens eine Klassenarbeit unter
                            &nbsp;<Link to={linkTriggerExamLoad}>
                                <Button variant="outline-primary" size="sm">
                                    Klassenarbeiten
                                </Button>
                            </Link>
                            &nbsp;in das System. F&uuml;hren Sie anschlie&szlig;end die Auswertung <span className="bold">und</span> die
                            Analyse durch. Dann k&ouml;nnen Sie Ihre Daten in die Werkzeugkette einspielen.
                        </h6>
                    </Alert>
                }

                {/* STATE: KA im System, aber noch nicht ausgewertet */}
                {(this.props.parentState.statusExams === "changed" && this.props.parentState.klassenarbeiten.length > 0) &&
                    <>
                        <Alert variant="warning" className="alert-crits">
                            <h6>Hinweis: Es gibt Änderungen in den Klassenarbeiten.<br />Es wurden Klassenarbeiten entfernt oder hinzugefügt.
                                {/* So sind keine sinnvollen Analyseschritte möglich. */}
                                &nbsp;Bitte f&uuml;hren Sie zuerst
                                eine <Link to="/auswertung/auswertung"><Button variant="outline-primary" size="sm">Auswertung</Button></Link> der aktuellen Daten durch.
                            </h6>
                        </Alert>
                    </>
                }

                {(this.props.parentState.klassenarbeiten.length > 0 &&
                    this.props.parentState.statusExams !== "changed") &&
                    <>
                        <Row className="mt-3">
                            <Col>
                                <Table striped bordered hover size="sm" >
                                    <thead>
                                        <tr><th>Dateiname</th><th>Jahr</th><th>Fach</th><th>Klasse</th>
                                            <th>DGSE Datenbank</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.parentState.klassenarbeiten.map((
                                            { schuljahr, fach, klasse, maxPunkte, grid, fileName, ...rest }, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{fileName}</td>
                                                    <td>{schuljahr}</td>
                                                    <td>{fach}</td>
                                                    <td>{klasse}</td>
                                                    <td>
                                                        {(this.props.parentState.klassenarbeiten[index].saved_to_webdb !== undefined) &&
                                                            <>
                                                                <span className="fw-bold text-success">Analyse erfolgreich übertragen.</span>
                                                            </>
                                                        }
                                                        {(this.props.parentState.helper.api.reply_data.length > 0) &&
                                                            ((this.props.parentState.klassenarbeiten[index].saved_to_webdb === undefined) &&
                                                                (trafficLightColor === "green")) &&
                                                            <>
                                                                {/* <button className="buttonDownload pointerFinger" onClick={() => this.handleTransferToWebDB(index)}>
                                                                    &#x2B06;DGSE Analyse in Webdatenbank übertragen
                                                                </button> */}

                                                                <Button
                                                                    variant="outline-primary"
                                                                    size="sm"
                                                                    onClick={() => this.handleTransferToWebDB(index)}
                                                                >
                                                                    Analyse & Dokumentation übertragen
                                                                </Button>

                                                            </>
                                                        }
                                                        {((this.props.parentState.helper.api.reply_data.length === 0) &&
                                                            ((this.props.parentState.klassenarbeiten[index].saved_to_webdb === undefined)) ||
                                                            (trafficLightColor !== "green")) &&
                                                            <>
                                                                {/* <span className="text-danger">Keine Schuldaten vorhanden. Stellen Sie eine Verbindung her.</span> */}
                                                                <span className="text-danger">Keine validen Schuldaten vorhanden</span>
                                                            </>
                                                        }
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>

                        {/* <Row>
                            <Col>
                                Sie können nun Ihre DGSE Analyse & Dokumentation (pro Klassenarbeit) in die DGSE Datenbank übertragen. Sie können die DGSE
                                DiSch für die Übertragung der Analyse & Dokumentation eingeben und
                                eine Verbindung herstellen.
                            </Col>
                        </Row> */}

                        <Row xs={1} md={2} className="g-4 d-flex align-items-stretch mt-0">
                            <Col className="d-flex">
                                <Card bg="light" text="dark" border="dark" className="flex-fill">
                                    <Card.Header>Verbindung mit der DGSE Datenbank herstellen</Card.Header>
                                    <Card.Body>
                                        <Card.Title>Verbindungsdaten</Card.Title>
                                        {/* <Card.Text> */}
                                        <>
                                            <Form>
                                                <Form.Group className="mb-3" controlId="formDisch">
                                                    <Form.Label>DiSch</Form.Label>
                                                    <Form.Control type="text"
                                                        placeholder="1234567890"
                                                        value={this.props.parentState.helper.api.disch}
                                                        onChange={(e) => this.handleDischChange(e)}
                                                        isInvalid={this.props.parentState.helper.api.disch.length !== 10}
                                                        isValid={this.props.parentState.helper.api.disch.length === 10}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Geben Sie den 10-stellige <span className="fw-bold">DGSE DiSch</span> Ihrer Schule ein.
                                                    </Form.Text>
                                                    {/* <Form.Control.Feedback type="invalid">
                                                        Der DiSch muss 10-stellig sein.
                                                    </Form.Control.Feedback> */}
                                                    {/* <Form.Control.Feedback type="valid">
                                                        Der DiSch hat genau 10 Ziffern enthalten.
                                                    </Form.Control.Feedback> */}
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formSchoolYear">
                                                    <Form.Label>Schuljahr</Form.Label>
                                                    <Form.Select aria-label="Auswahl Schuljahr"
                                                        id="fSchoolYear" onChange={(e) => this.handleSchoolYearChange(e)}
                                                        className="form-select"
                                                        value={this.props.parentState.helper.api.school_year_name}>
                                                        {Array.from({ length: (new Date().getFullYear() + 2) - 2020 + 1 }, (_, i) => {
                                                            const year = 2020 + i;
                                                            return (
                                                                <option key={year} value={`${year}/${year + 1}`}>
                                                                    {`${year}/${year + 1}`}
                                                                </option>
                                                            );
                                                        })}
                                                    </Form.Select>
                                                    <Form.Text className="text-muted">
                                                        Bitte wählen Sie das gewünschte Schuljahr aus.
                                                    </Form.Text>
                                                </Form.Group>
                                            </Form>
                                            {/* </Card.Text> */}
                                        </>
                                    </Card.Body>
                                    <Card.Footer className="d-flex justify-content-center">
                                        <Button variant="outline-primary"
                                            type="submit"
                                            size="sm"
                                            className="button-hover-white"
                                            onClick={() => this.handleConnectWebDB()}
                                            disabled={this.props.parentState.helper.api.disch.length !== 10 || isConnecting}
                                        >
                                            {isConnecting ? (
                                                <>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                    &nbsp;Verbindung wird hergestellt...
                                                </>
                                            ) : (
                                                this.props.parentState.helper.api.disch.length !== 10 ?
                                                    'DGSE DiSch nicht korrekt - Verbindung nicht möglich' :
                                                    'Verbindung herstellen'
                                            )}
                                        </Button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col className="d-flex">
                                <Card bg="light" text="dark" border="dark" className="flex-fill">
                                    {/* <Card.Header as="h5">Status der Verbindung</Card.Header> */}
                                    <Card.Header className="d-flex align-items-center justify-content-between">
                                        {/* <div className="d-flex align-items-center justify-content-between"> */}
                                        <span>Status der Verbindung</span>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="traffic-light-tooltip" className="custom-tooltipper">
                                                    {trafficLightColor === 'green' && "Verbindung erfolgreich hergestellt. Sie können die Analyse in die Webdatenbank übertragen."}
                                                    {trafficLightColor === 'orange' && "Die Verbindung zur Webdatenbank wurde erfolgreich hergestellt. Leider sind die Daten des Schuljahres unvollständig. Eine Übertragung Ihrer Analyse ist nicht möglich."}
                                                    {trafficLightColor === 'red' && "Es besteht keine valide Verbindung zur Webdatenbank. Bitte überprüfen Sie Ihre Eingaben."}
                                                </Tooltip>}
                                        >
                                            <div
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    borderRadius: '50%',
                                                    backgroundColor: trafficLightColor,
                                                    marginLeft: '10px',
                                                    display: 'inline-block',
                                                    cursor: 'pointer',
                                                }}
                                            // title={
                                            //     trafficLightColor === 'green' ? "All set" :
                                            //     trafficLightColor === 'orange' ? "Connection OK, data missing" :
                                            //     "Unable to connect"
                                            // }
                                            ></div>
                                        </OverlayTrigger>
                                    </Card.Header>
                                    {/* </div> */}
                                    <Card.Body>
                                        <Card.Title>
                                            {(api.connected) &&
                                                <>
                                                    Zuletzt: {api.last_connect}
                                                </>
                                            }
                                            {(!api.connected) &&
                                                <>
                                                    Keine valide Verbindung
                                                </>
                                            }
                                        </Card.Title>
                                        <Card.Text>
                                            <AnalysisExportStatusBlock
                                                parentState={this.props.parentState}
                                            />
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                }

                {/* STATE: KA im System und ausgewertet. Verbindung noch nicht hergestellt oder zu alt */}
                {/* {(this.props.parentState.klassenarbeiten.length > 0 &&
                    this.props.parentState.statusExams === "unchanged") &&
                    <>

                        <div>
                            <div>
                                {console.log(this.props.parentState)}
                                <h3>Verbindung mit der Webdatenbank herstellen</h3>

                                <p>Um die schuljahr-scharfen Klassen und Fächer zu laden,
                                    geben Sie bitte die <span className="fw-bold">Disch</span> Ihrer
                                    Schule ein und wählen Sie
                                    ein <span className="fw-bold">Schuljahr</span>.
                                    Klicken Sie
                                    dann bitte auf <span className="rounded-pill text-light bg-primary p-1">&nbsp;Verbindung herstellen&nbsp;</span>.
                                </p>

                                

                            </div>

                            <div className="row">
                                <div className="col">
                                    <AnalysisExportStatusBlock
                                        parentState={this.props.parentState}
                                    />
                                </div>
                                <div className="col">
                                    <div className="row">
                                        <div className="col fw-bold">Verbindungsdaten:</div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label htmlFor="fDisch" className="col-sm-2 col-form-label">Disch</label>
                                        <div className="col-sm-10">
                                            <input type="text" className="form-control" id="fDisch"
                                                // pattern="[1-9]{1}[0-9]{9}"
                                                placeholder="0123456789"
                                                value={this.props.parentState.helper.api.disch}
                                                onChange={(e) => this.handleDischChange(e)}
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label htmlFor="fSchoolYear" className="col-sm-2 col-form-label">Schuljahr</label>
                                        <div className="col-sm-10">
                                            <select id="fSchoolYear" onChange={(e) => this.handleSchoolYearChange(e)}
                                                className="form-select"
                                                value={this.props.parentState.helper.api.school_year_name}
                                            >
                                                {Array.from({ length: (new Date().getFullYear() + 2) - 2020 + 1 }, (_, i) => {
                                                    const year = 2020 + i;
                                                    return (
                                                        <option key={year} value={`${year}/${year + 1}`}>
                                                            {`${year}/${year + 1}`}
                                                        </option>
                                                    );
                                                })}

                                            </select>
                                        </div>
                                    </div>
                                    <div className='mb-3 row'>

                                        <button className="btn btn-primary"
                                            onClick={() => this.handleConnectWebDB()}
                                            type="submit">Verbindung herstellen</button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </>
                } */}


            </>
        )
    }
}
